export default __webpack_public_path__ + "book.a4c3f4813013ed4b80da.svg";